
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/how-to-enjoy-your-holidays-to-the-max",
      function () {
        return require("private-next-pages/blog/how-to-enjoy-your-holidays-to-the-max.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/how-to-enjoy-your-holidays-to-the-max"])
      });
    }
  